import React, { useState } from "react";
import TextInputFormik from "../../lib/Common/TextInputFormik";
import Dropdown from "../../lib/Common/Dropdown";
import { useFormik } from "formik";
import BackNextButtons from "../../lib/Common/BackNextButtons";
import { useTranslation } from "react-i18next";
import { contractSchema } from "../../validations/schema";
import { validateCusomerId } from "../../apis/Offers";
import Loader from "../../lib/Common/loader";

const PersonalInformationTab = ({
  formData,
  updateFormData,
  currentStep,
  setCurrentStep,
  values,
  setStep,
  showSave,
  backStep,
}) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const salutationOptions = [
    { value: "Herr", label: t("salutationOptions.Herr") },
    { value: "Frau", label: t("salutationOptions.Frau") },
    { value: "Divers", label: t("salutationOptions.Divers") },
  ];

  const formik = useFormik({
    initialValues: formData?.personalInformation,
    validationSchema: values?.customerType
      ? contractSchema(values?.customerType)
      : null,
    onSubmit: async (v) => {
      updateFormData({
        ...formData,
        personalInformation: {
          ...formData.personalInformation,
          ...v,
        },
      });
    },
  });

  return (
    <div className="px-0">
      <h2 className="fontSize32Regular lineHeight38 mb-3 mb-md-5 textGreen">
        {values?.customerType === "business" ? (
          <>{t("Company Information")}</>
        ) : (
          <>{t("Personal Information")}</>
        )}
      </h2>
      <div className="row g-md-3 g-1  mb-md-2">
        <div className="col-lg-2 col-md-6 mb-1 mb-md-2">
          <Dropdown
            label={t("Salutation")}
            placeholder={""}
            value={salutationOptions.find(
              (option) => option.value === formik.values.salutation
            )}
            onChange={(value) => {
              formik.setFieldValue("salutation", value.value);
            }}
            options={salutationOptions}
            required
          />
          {(formik.submitCount > 0 || formik?.touched?.salutation) &&
            formik.errors?.salutation && (
              <p className="fontSize14Medium lineHeight1_2 text-pink mt-1 mb-0">
                {t(`${formik.errors?.salutation}`)}
              </p>
            )}
        </div>
        <div className="col-lg-5 col-md-6">
          <TextInputFormik
            label={t("First name")}
            field="first_name"
            formik={formik}
            required
          />
        </div>
        <div className="col-lg-5 col-md-6 mb-1 mb-md-2">
          <TextInputFormik
            label={t("Last name")}
            field="last_name"
            formik={formik}
            required
          />
        </div>
      </div>

      <div className="row g-md-3 g-2 mb-1 mb-md-2">
        <div className="col-md-6">
          <TextInputFormik
            label={t("Email Address")}
            field="email"
            type="email"
            formik={formik}
            placeholder="e.g john.smith@email.com"
            required
          />
        </div>
        <div className="col-md-6">
          <TextInputFormik
            label={t("Phone Number")}
            type="text"
            field="telephone"
            formik={formik}
            placeholder="+49 30 12345678"
          />
        </div>
      </div>

      {values?.customerType === "business" && (
        <>
          <div className="row g-md-3 g-2 mb-1 mb-md-2">
            <div className="col-md-6 ">
              <TextInputFormik
                label={t("Company Name")}
                field="company_name"
                formik={formik}
                required
              />
            </div>
            <div className="col-md-6  mt-md-3 mt-2 ">
              <TextInputFormik
                label={t("Tax ID")}
                field="tax_number"
                formik={formik}
                placeholder="e.g DE123456789"
              />
            </div>
          </div>
        </>
      )}
      <div className="textWhite fontSize14Medium  mt-md-3 mt-2 mb-md-2 mb-1 ">
        {t("Are you Existing Customer")}
      </div>
      <div className="d-flex align-items-start gap-2 mb-md-3 mb-2">
        <TextInputFormik
          // label={t("Yes")}
          type="radio"
          field="existing"
          formik={formik}
          value={true}
          onChange={() => {
            formik.setFieldValue("existing", true);
            formik.setFieldValue("consumer_id", "");
            formik.setFieldValue("username", "");
          }}
          style="form-check-input mt-2 backgroundColorCommon borderColorlightgray cursor-pointer"
        />
        <label className="form-check-label text-white lineHeight24 fontSize13Regular me-4 mt-1">
          {t("Yes")}
        </label>

        <TextInputFormik
          // label={t("No")}
          style="form-check-input mt-2 backgroundColorCommon borderColorlightgray cursor-pointer"
          type="radio"
          field="existing"
          formik={formik}
          value={false}
          onChange={() => {
            formik.setFieldValue("existing", false);
            formik.setFieldValue("consumer_id", "");
            formik.setFieldValue("username", "");
          }}
        />

        <label className="form-check-label text-white lineHeight24 fontSize13Regular mt-1">
          {t("no")}
        </label>
      </div>
      {(formik.submitCount > 0 || formik.touched?.existing) &&
        formik.errors?.existing && (
          <p className="fontSize14Medium lineHeight1_2 text-pink mt-n25px">
            {t(`${formik.errors?.existing}`)}
          </p>
        )}

      {formik?.values?.existing == true ? (
        <TextInputFormik
          label={t("Customer Id")}
          field="consumer_id"
          formik={formik}
          required
        />
      ) : (
        <TextInputFormik
          label={t("Username")}
          field="username"
          formik={formik}
          required
        />
      )}

      <div className="mt-5 ">
        {loading ? (
          <Loader />
        ) : (
          <BackNextButtons
            setStep={setStep}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            onClick={async (nextStep) => {
              const errors = await formik.validateForm();
              formik.handleSubmit();
              if (Object.keys(errors).length > 0) return false;
              setLoading(true);
              let res;
              if (formik?.values?.consumer_id) {
                res = await validateCusomerId({
                  saas_customer_lead_id: formik?.values?.consumer_id,
                });
              }
              if (res?.success) {
                setCurrentStep(nextStep);
              } else {
                if (formik?.values?.consumer_id)
                  formik.setErrors({ ...errors, consumer_id: res?.message });
                else if (!formik?.values?.consumer_id) setCurrentStep(nextStep);
              }
              setLoading(false);
            }}
            values={{
              ...formData,
              personalInformation: formik.values,
              ...values,
            }}
            backStep={backStep}
            showSave={showSave}
          />
        )}
      </div>
    </div>
  );
};

export default PersonalInformationTab;
